module.exports = __webpack_public_path__ + "h5/img/hope-title1.8f1acf58.png";